import * as actionTypes from './actionTypes'
import * as mutationTypes from './mutationTypes'
import { opinionRequirementsApi } from '../../api/api.opinion.requirements.service'

export default {
  [actionTypes.GET_EXPERTS](store, { search, take }) {
    return opinionRequirementsApi.getExperts(search, take).then(r => {
      return store.commit(mutationTypes.EXPERTS_UPDATED, r)
    })
  },
}
